import { AdProps, Size } from '../../types/AdProps';

function getAdUnitName({ isDesktop, size, depth }: { isDesktop: boolean, size: Size, depth?: number }) {
  if (size === Size.MedRectangle) {
    return isDesktop ? `desktop-slideshow-in-content-right-depth-${depth}` : `mobile-below_fold_content-high-viewability-depth-${depth}`;
  } else {
    return 'mobile-slideshow_leaderboard';
  }
}

const VerticalAd = (props: AdProps) => {
  const { depth, size, hide } = props;
  const isDesktop = (window as any).phpVariables.deviceType === 'desktop';
  const adUnitIdentifier = getAdUnitName({ isDesktop, size, depth });
  const isMediumRectangle = size === Size.MedRectangle;

  const adContainerStyle = isMediumRectangle ? {
    overflow: 'hidden',
    height: '315px',
    width: '100%',
    backgroundColor: 'rgba(240, 240, 240, 0.375)',
    marginBottom: '0',
    display: 'flex',
    paddingBottom: '5px',
    marginTop: '-10px',
  } : {
    minWidth: '320px',
    minHeight: '50px',
    overflow: 'visible',
    maxHeight: '90px',
    backgroundColor: 'white',
    flexGrow: 1,
    alignItems: 'center',
    display: 'flex'
  };

  const adStyle = isMediumRectangle ? {
    minWidth: '300px',
    minHeight: '250px',
    overflow: 'hidden',
    maxHeight: '600px',
    flexGrow: 1,
    alignItems: 'center',
  } : {
    minWidth: '320px',
    minHeight: '50px',
    overflow: 'hidden',
    maxHeight: '90px',
    flexGrow: 1,
    alignItems: 'center',
  };

  return (
    <div>
      { hide ? null : <figure
        className="article-ad-vertical flex flex-col items-center"
        id={`${adUnitIdentifier}-container`}
        style={adContainerStyle}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            style={{
              flexGrow: 1,
              backgroundColor: 'white',
              height: '0',
              margin: '0 12px 0 12px',
            }}
          ></div>
          <figcaption
            className="article-ad-caption"
            style={{
              color: 'black',
              background: 'unset',
              width: 'unset',
              fontSize: '0.7rem',
              marginBottom: '-5px',
            }}
          >
            Advertisement -{' '}
            <span
              style={{
                fontSize: '0.7rem',
                opacity: 0.45,
              }}
            >
              Continue Below
            </span>
          </figcaption>
          <div
            style={{
              flexGrow: 1,
              backgroundColor: 'white',
              height: '0',
              margin: '0 12px',
            }}
          ></div>
        </div>

        <div
          id={adUnitIdentifier}
          className="flex justify-items-center justify-content-center ad-item"
          style={adStyle}
        ></div>
      </figure> }
    </div>
  );
};

export default VerticalAd;
